import React, { useState, useEffect, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { getFormSyncErrors, getFormValues, change } from "redux-form";
import CustomersGrid from "./CustomersGrid";
import DynamicForm from "../common/DynamicForm";
import { connect } from "react-redux";
import { GET_MAX_FILE_SIZE_FROM_DICT } from "constants/index";
import { get } from "lodash";
import useDebounce from "../../../custom-hooks/useDebounce";

import "./styles.scss";

const FORM_NAME_CUSTOMER = "compact-search-customer-form";
const FORM_NAME_SELECTED_CUSTOMER = "compact-search-customer-form-selected";

const mapStateToProps = (state) => ({
    cusomerValues: getFormValues(FORM_NAME_CUSTOMER)(state),
    // customerErrors: getFormSyncErrors(FORM_NAME_CUSTOMER)(state),
});

const mapDispatchToProps = { change };

const CompactCustomerSearch = props => {
    const {
        t,
        change,
        customerCardId, // pre-selected customer id - we should not display anything
        cusomerValues,
        onCustomerQuery,
        onCustomerSelected,
        preselectedCustomer,
        disabled
    } = props;

    const [state, setState] = useState({
        customerQuery: "",
        customerSelected: null,
    });

    const [isForceHiddenController, setIsForceHiddenController] = useState(false);
    const { customerQuery, customerSelected } = state;

    const { debouncedValue: debouncedCustomerQuery } = useDebounce(customerQuery, 300);

    const customerQueryValue = useMemo(() => cusomerValues && cusomerValues.customer, [cusomerValues]);

    const maxFileSize = useMemo(() => GET_MAX_FILE_SIZE_FROM_DICT("form"), []);

    const customerForm = t => {
        const widgets = [];
        // add customer query card
        if (!customerCardId) {
            const customerQueryWidget = {
                key: "customer",
                title: t("orderCustomer"),
                isReq: true,
                clearable: false,
                widgetType: "input",
                disabled: disabled
            };
            widgets.push(customerQueryWidget);
        }
        const defaultBlock = {
            view: "1column",
            collapsed: false,
            key: FORM_NAME_CUSTOMER,
            widgets,
        };
        const blocks = [defaultBlock];
        return blocks;
    };
    // selected customer form (former CustomerInfo component)
    const selectedCustomerForm = t => {
        const selectedCustomerBlock = {
            view: "2column",
            collapsed: false,
            key: "create-new-order-form-customer-info",
            widgets: [
                {
                    key: "customerId",
                    title: t("Ідентифікатор"),
                    disabled: true,
                    savedValue: customerSelected.id ? customerSelected.id : "",
                    widgetType: "input",
                },
                {
                    key: "customerFullName",
                    title: t("Повна назва"),
                    disabled: true,
                    savedValue:  get(customerSelected, "fullName", "") || get(customerSelected, "name", ""),
                    widgetType: "input",
                },
                // commented out as per Oleg request 11.03.2025
                // {
                //     key: "customerAccount",
                //     title: t("Особовий рахунок"),
                //     disabled: true,
                //     savedValue: customerSelected.taxId ? customerSelected.taxId : "",
                //     widgetType: "input",
                // },
                // {
                //     key: "customerEDRPOU",
                //     title: t("Код ЄДРПОУ"),
                //     disabled: true,
                //     savedValue: customerSelected.institutionId ? customerSelected.institutionId : "",
                //     widgetType: "input",
                // },
            ],
        };

        return [selectedCustomerBlock];
    };

    const setCustomersQuery = query => {
        setIsForceHiddenController(true); // hack to properly reposition the FieldController of customer query field
        const customerSelectedName = get(customerSelected, "fullName") || get(customerSelected, "name");
        //  case if customer was selected and search started again, make sure that query is not equal to customer selected fullName
        if (customerSelected && query !== customerSelectedName) {
            // setState(state => ({ ...state, customerQuery: "", customerSelected: null }));
            setState(state => ({ ...state, customerSelected: null }));
            if (onCustomerSelected && typeof onCustomerSelected === "function") {
                onCustomerSelected(null);
            }
        }
        // start search from at least one symbol and clear query if not
        if (!query || !query.length) return;

        // set new customerQuery so grid will update
        setState(state => ({ ...state, customerQuery: query }));
        if (onCustomerQuery && typeof onCustomerQuery === "function") {
            onCustomerQuery(query);
        }
        setTimeout(() => {
            setIsForceHiddenController(false); // hack to properly reposition the FieldController of customer query field
        }, 0);
    };

    // callback from grid row click
    const selectCustomer = customer => {
        setState(state => ({ ...state, customerSelected: customer }));

        const customerName = get(customer, "fullName") || get(customer, "name");
        change(FORM_NAME_CUSTOMER, "customer", customerName); // set input value to match clicked customer fullname
        if (onCustomerSelected && typeof onCustomerSelected === "function") {
            onCustomerSelected(customer);
        }
    };

    useEffect(() => {
        setCustomersQuery(customerQueryValue);
    }, [customerQueryValue]);

    useEffect(() => {
        if (preselectedCustomer) {
            selectCustomer(preselectedCustomer)
        }
    }, []);

    if (customerCardId) {
        return null;
    }

    return (
        <>
            <div className="compact-customer-search-query">
                <DynamicForm
                    t={t}
                    formName={FORM_NAME_CUSTOMER}
                    dynData={customerForm(t)}
                    objectId={null}
                    currentId={null}
                    objectType="TASK"
                    maxFileSize={maxFileSize}
                    isForceHiddenController={isForceHiddenController}
                    withoutLiveSaver
                />
            </div>

            {!customerSelected && !customerCardId && !disabled && (
                <>
                    {debouncedCustomerQuery ? (
                        <CustomersGrid gridSearch={debouncedCustomerQuery} selectItem={selectCustomer} />
                    ) : (
                        <div className="content-wrapper" />
                    )}
                </>
            )}
            {customerSelected && (
                <div className="compact-customer-search-selected-info">
                    <DynamicForm
                        t={t}
                        disabled
                        formName={FORM_NAME_SELECTED_CUSTOMER}
                        dynData={selectedCustomerForm(t)}
                        objectId={null}
                        currentId={null}
                        objectType="TASK"
                        maxFileSize={maxFileSize}
                        withoutLiveSaver
                    />
                </div>
            )}
        </>
    );
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CompactCustomerSearch));
